import { unitMapping } from '#src/lib/style.ts';

import type { IconColor } from './useIconColor.tsx';
import { useIconColor } from './useIconColor.tsx';

type Props = {
  size?: keyof typeof unitMapping;
  color?: IconColor;
};

export const TopPlayers = ({ size = 3, color }: Props) => {
  const { fill } = useIconColor(color);

  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98733 4.09375C5.67483 4.3125 4.48733 4.90625 3.58108 5.78125L0.081084 0.8125C-0.137666 0.46875 0.112334 0 0.518584 0H4.26858C4.42483 0 4.61233 0.09375 4.67483 0.25L6.98733 4.09375ZM8.01858 5C11.0498 5 13.5186 7.46875 13.5186 10.5C13.5186 13.5625 11.0498 16 8.01858 16C4.95608 16 2.51858 13.5625 2.51858 10.5C2.51858 7.46875 4.95608 5 8.01858 5ZM10.8936 9.9375C11.1123 9.71875 10.9873 9.34375 10.7061 9.3125L9.04983 9.0625L8.33108 7.59375C8.26858 7.46875 8.14358 7.40625 7.98733 7.40625C7.86233 7.40625 7.73733 7.46875 7.67483 7.59375L6.95608 9.0625L5.29983 9.3125C5.01858 9.34375 4.89358 9.71875 5.11233 9.9375L6.29983 11.0938L6.01858 12.7188C5.95608 13 6.26858 13.2188 6.54983 13.0938L7.98733 12.3125L9.45608 13.0938C9.73733 13.25 10.0498 13 9.98733 12.7188L9.70608 11.0938L10.8936 9.9375ZM15.4873 0C15.8936 0 16.1436 0.46875 15.9248 0.78125L12.4248 5.75C11.5186 4.875 10.3311 4.28125 9.01858 4.0625L11.2998 0.25C11.3936 0.09375 11.5811 0 11.7373 0H15.4873Z"
        fill={fill}
      />
    </svg>
  );
};
